import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ScontoMaggiorazionePRModalComponent } from './sconto-maggiorazione-modal-component';

export const ScontoMaggiorazionePRModalModule: string = ng
    .module('sconto-maggiorazione-modal-component', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('scontoMaggiorazionePRModalComponent', ScontoMaggiorazionePRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/sconto-maggiorazione-modal-component/sconto-maggiorazione-modal-component.module.ts